import React from "react";
import "../styles/About.css";
import FadeInSection from "./FadeInSection";

class About extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1",
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey,
    });
  }

  render() {
    const one = (
      <div>
        <p>
          I am currently a Software Global Support Engineer at{" "}
          <a href="https://www.bystronic.com/" target="_blank" rel="noopener noreferrer">
            Bystronic
          </a>
          , overseeing, troubleshooting, and enhancing global software solutions to ensure stability, performance, and reliability.
        </p>
        <p>
          Previously, I worked as a Software Engineer for institutions such as{" "}
          <strong>Osakidetza (Basque Health Service)</strong> and the{" "}
          <strong>CNMV (National Securities Market Commission)</strong>, developing and maintaining critical software systems used in healthcare and financial sectors.
        </p>
        <p>
          My experience includes integrating complex data systems, creating automation tools, and ensuring optimal performance and reliability for mission-critical applications.
        </p>
      </div>
    );

    const two = (
      <div>
        <p>
          Outside of work, I'm passionate about running, fitness, and exploring new advancements in technology and science.
        </p>
        <p>
          I'm also a lifelong gamer and enjoy challenging myself both mentally and physically.
        </p>
      </div>
    );

    const tech_stack = [
      ".NET Framework",
      ".NET CORE",
      "C#",
      "JavaScript ES6+",
      "TypeScript",
      "Python",
      "Java",
      "React.js",
      "MySQL",
      "Solidity",
      "Android",
      "Git",
    ];

    return (
      <div id="about">
        <FadeInSection>
          <div className="section-header">
            <span className="section-title">/ About me</span>
          </div>
          <div className="about-content">
            <div className="about-description">
              {one}
              {/* <p>Here are some technologies I have been working with:</p>
              <ul className="tech-stack">
                {tech_stack.map((tech_item) => (
                  <FadeInSection key={tech_item} delay={`${tech_stack.indexOf(tech_item) + 1}00ms`}>
                    <li>{tech_item}</li>
                  </FadeInSection>
                ))}
              </ul>
      */}
            </div>
            <div className="about-image">
              <img alt="Ander Alvarez" src="/assets/me.jpg" />
            </div>
          </div>
        </FadeInSection>
      </div>
    );
  }
}

export default About;
